import { NotificationStatus } from '../../models/notification.model';
import { Router } from '@angular/router';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HandsetService } from 'src/app/core/services/handset.service';
import { Notification } from '../../models/notification.model';
import { NotificationStoreService } from '../../services/notification.service';
import { take } from 'rxjs/operators';

@Component({
standalone: false,
  selector: 'app-notifications-actions-menu',
  styleUrls: ['./notifications-actions-menu.component.scss'],
  templateUrl: './notifications-actions-menu.component.html',
})
export class AppNotificationsActionsMenuComponent {
  @Input() public notification: Notification;
  @Output() public handleClose = new EventEmitter<void>();

  public NotificationStatus = NotificationStatus;
  public visible = false;

  constructor(
    public handsetService: HandsetService,
    private router: Router,
    private notificationService: NotificationStoreService,
  ) {}

  public redirectToSettings() {
    this.router.navigate(['settings']).finally(() => this.handleClose.next());
  }

  public markAs(newNotificationStatus: NotificationStatus) {
    this.notificationService
      .changeReadStatus(this.notification.notificationId, newNotificationStatus)
      .pipe(take(1))
      .subscribe(() => this.changeVisibility());
  }

  public mobileMenuClicked(event: Event) {
    this.stopPropagation(event);
    this.changeVisibility();
  }

  public stopPropagation(event: Event) {
    event.stopPropagation();
  }

  public changeVisibility() {
    this.visible = !this.visible;
  }
}
